export const MOTIFS_DEPART_SALARIE = [
    'DEBAUCHE',
    'DEMISSION',
    'LICENCIEMENT',
    'FIN_DE_CONTRAT',
    'RETRAITE',
    'DECES',
    'AUTRE',
];
export const LIBELLE_MOTIF_DEPART = {
    DEBAUCHE: 'Débauche',
    DEMISSION: 'Démission',
    LICENCIEMENT: 'Licenciement',
    FIN_DE_CONTRAT: 'Fin de contrat',
    RETRAITE: 'Départ à la retraite',
    DECES: 'Décès',
    AUTRE: 'Autre motif',
};
export const MOTIFS_REFUS_DEPART = [
    'PAS_UN_SALARIE',
    'INFIRME',
    'A_CONFIRMER',
    'DEJA_INACTIF',
];
const MESSAGES_DEPART = {
    PAS_UN_SALARIE: 'Seul un salarié se déclare parti. Un conjoint ou un enfant se retire de la couverture.',
    INFIRME: 'Cette fiche est infirmée : elle n’est déjà plus couverte.',
    A_CONFIRMER: 'Cette fiche attend encore sa confirmation : infirmez-la plutôt.',
    DEJA_INACTIF: 'Ce salarié n’est déjà plus couvert.',
};
/** Seul un salarié confirmé et encore couvert se déclare parti. */
export function peutDeclarerDepart(p) {
    const refus = (motif) => ({
        possible: false,
        motif,
        message: MESSAGES_DEPART[motif],
    });
    if (p.typeBeneficiaire !== 'TITULAIRE')
        return refus('PAS_UN_SALARIE');
    if (p.etatConfirmation === 'INFIRME')
        return refus('INFIRME');
    if (p.etatConfirmation === 'A_CONFIRMER')
        return refus('A_CONFIRMER');
    if (p.statut !== 'ACTIF')
        return refus('DEJA_INACTIF');
    return { possible: true };
}
/**
 * Parti par CE geste : un salarié désactivé à la main, motif de départ posé.
 * Un départ lu dans un DNS, une résiliation de l'entreprise, ne s'annulent
 * pas d'ici.
 */
export function estPartiALaMain(p) {
    return (p.typeBeneficiaire === 'TITULAIRE' &&
        p.statut === 'INACTIF' &&
        p.motifInactivite === 'DESACTIVATION_MANUELLE' &&
        p.motifDepart !== null);
}
/**
 * La date de départ ne peut pas être dans le futur : le geste coupe les
 * droits maintenant. Un départ annoncé pour la fin du mois s'enregistre ce
 * jour-là. `aujourdHui` au format AAAA-MM-JJ, passé par l'appelant.
 */
export function dateDeDepartRecevable(dateDepart, aujourdHui) {
    return dateDepart <= aujourdHui;
}
//# sourceMappingURL=depart-salarie.js.map